import config from '../config';
import event from './event';
import { nextTick } from 'vue';

import { isRouteIgnored, isRoute, isRouter } from '../helpers';

export default function page(...args) {
  if (args.length && !args[0]) {
    // prevents tracking with bo arguments
    return;
  }

  let route;

  if (args.length && isRouter(args[0])) {
    route = args[0].currentRoute;
  }

  if (args.length && isRoute(args[0])) {
    route = args[0];
  }

  if (route) {
    addRoute(route);
  }
}

export function addRoute(route) {
  if (isRouteIgnored(route)) {
    return;
  }
  // post event to backend
  event({
    type: 'ROUTE_CHANGE',
    routeName: route.value.name,
    routePath: route.value.fullPath,
  });
}

export async function enablePageAutoTracking() {
  const { router } = config;

  if (!router) {
    return;
  }

  try {
    await router.isReady();
    addRoute(router.currentRoute);

    router.afterEach((to, from) => {
      if (to == from) {
        return;
      }
      nextTick().then(() => {
        addRoute(router.currentRoute);
      });
    });
  } catch (err) {
    // onError
  }
}
